export default "__VITE_ASSET__BqAuK1L1__"